export default defineNuxtPlugin((nuxtApp) => {
  const authStore = useAuthStore();

  nuxtApp.vueApp.directive('permission', {
    mounted(el, binding) {
      const { value } = binding;
      // value can be string 'permission' or array ['permission', 'feature'] or object { permission: '', feature: '' }
      
      if (!value) return;

      let hasAccess = true;

      if (typeof value === 'string') {
        hasAccess = authStore.hasPermission(value);
      } else if (Array.isArray(value)) {
         // Assume OR logic for array of permissions? Or AND? 
         // Usually simple string is enough. Let's support simple string first.
         // If array, check if user has ANY of them? Or ALL? 
         // Let's stick to simple string or object for now to match Sidebar logic.
         // Sidebar logic: item.permission && item.feature. AND logic.
      } else if (typeof value === 'object') {
          if (value.permission && !authStore.hasPermission(value.permission)) hasAccess = false;
          if (value.feature && !authStore.hasFeature(value.feature)) hasAccess = false;
      }

      if (!hasAccess) {
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        } else {
            el.style.display = 'none';
        }
      }
    },
    // Handle updates if permission/user changes dynamically (rare but good practice)
    updated(el, binding) {
        const { value } = binding;
        if (!value) return;
        
        // Re-check logic similar to mounted
         let hasAccess = true;

        if (typeof value === 'string') {
            hasAccess = authStore.hasPermission(value);
        } else if (typeof value === 'object') {
            if (value.permission && !authStore.hasPermission(value.permission)) hasAccess = false;
            if (value.feature && !authStore.hasFeature(value.feature)) hasAccess = false;
        }

        if (!hasAccess) {
             el.style.display = 'none';
             // Note: removeChild is destructive, simple toggle display is safer for updates
        } else {
             el.style.display = '';
        }
    }
  });
  
  // Helper for feature checking
  nuxtApp.vueApp.directive('feature', {
      mounted(el, binding) {
          const feature = binding.value;
          if (feature && !authStore.hasFeature(feature)) {
              if (el.parentNode) el.parentNode.removeChild(el);
              else el.style.display = 'none';
          }
      },
      updated(el, binding) {
          const feature = binding.value;
          if (feature && !authStore.hasFeature(feature)) {
             el.style.display = 'none';
          } else {
             el.style.display = '';
          }
      }
  });
});
